export const SERVICES = [
    {
        slug: "garden-maintenance",
        title: "Garden Maintenance",
        short: "Regular care that keeps your garden vibrant, healthy and stress-free.",
        long: "Scheduled pruning, soil care, pest control and seasonal refresh. We take the guesswork out of green spaces.",
        image:
            "https://images.unsplash.com/photo-1724556295135-ff92b9aa0a55?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxnYXJkZW5pbmclMjBtYWludGVuYW5jZXxlbnwwfHx8fDE3NzY3NjQ0MTR8MA&ixlib=rb-4.1.0&q=85&w=1400",
        icon: "Sprout",
        for: "Homes, villas, offices & housing societies",
    },
    {
        slug: "indoor-outdoor-plants",
        title: "Indoor & Outdoor Plants",
        short: "Handpicked healthy plants that thrive in your exact light & space.",
        long: "From low-light beauties to sun-lovers — each plant chosen for your environment, not a random catalogue.",
        image:
            "https://images.pexels.com/photos/4505176/pexels-photo-4505176.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
        icon: "Leaf",
        for: "Apartment balconies, living rooms, terraces",
    },
    {
        slug: "pots-planters",
        title: "Pots & Planters",
        short: "Curated pots — terracotta, ceramic, fibre — that elevate every plant.",
        long: "Designer and functional planters in multiple sizes, finishes and budgets. Drainage-tested.",
        image:
            "https://images.unsplash.com/photo-1634886153044-17aff58eb865?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxpbmRvb3IlMjBwbGFudHMlMjBwb3R8ZW58MHx8fHwxNzc2NzY0NDE0fDA&ixlib=rb-4.1.0&q=85&w=1400",
        icon: "FlowerPot",
        for: "Gifting, balcony styling, landscape projects",
    },
    {
        slug: "soil-fertilizer",
        title: "Soil, Fertilizer & Compost",
        short: "Premium potting mix, vermicompost and cocopeat — agronomist-approved.",
        long: "Organic-first. We stock what actually works for Indian homes and climates.",
        image:
            "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?auto=format&fit=crop&w=1400&q=80",
        icon: "Shovel",
        for: "DIY gardeners & serious hobbyists",
    },
    {
        slug: "green-wall-maintenance",
        title: "Green Wall Maintenance",
        short: "Keep your vertical gardens lush — long after installation day.",
        long: "Irrigation checks, plant replacement, nutrition cycles and troubleshooting for living walls.",
        image:
            "https://res.cloudinary.com/dvtaslagk/image/upload/q_auto/f_auto/v1777018977/greenwall_ejwmmd.jpg",
        icon: "LayoutGrid",
        for: "Cafés, offices, retail, premium homes",
    },
    {
        slug: "consultation",
        title: "Gardening Consultation",
        short: "1-on-1 advice from a BSc Agriculture expert — online or on-site.",
        long: "Plant selection, layout, pest diagnosis, watering schedules and long-term care plans.",
        image:
            "https://images.unsplash.com/photo-1466692476868-aef1dfb1e735?auto=format&fit=crop&w=1400&q=80",
        icon: "Compass",
        for: "First-time plant parents & renovators",
    },
];

export const KOKEDAMA = {
    tagline: "Our Specialty",
    title: "Kokedama — the art of moss-ball gardening",
    description:
        "Handmade, eco-friendly and unforgettable. Each Kokedama is crafted with care — a living sculpture that makes a thoughtful gift or a striking corner in your home.",
    bullets: [
        "100% soil-less moss wrap",
        "Perfect for gifting — weddings, housewarmings",
        "Limited handmade stock each month",
    ],
    main:
        "https://images.unsplash.com/photo-1760863264489-b051feacddaf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHw0fHxrb2tlZGFtYSUyMHBsYW50fGVufDB8fHx8MTc3Njc2NDQxNHww&ixlib=rb-4.1.0&q=85&w=1400",
    detail:
        "https://res.cloudinary.com/dvtaslagk/image/upload/q_auto/f_auto/v1777018977/kokedama_wyk7n7.jpg",
};

export const GALLERY = [
    { cat: "Balcony Gardens", url: "https://images.unsplash.com/photo-1519378058457-4c29a0a2efac?auto=format&fit=crop&w=1200&q=80" },
    { cat: "Indoor Setups", url: "https://res.cloudinary.com/dvtaslagk/image/upload/q_auto/f_auto/v1778769013/snakeplant_xvdxsl.png" },
    { cat: "Kokedama", url: "https://res.cloudinary.com/dvtaslagk/image/upload/q_auto/f_auto/v1777019709/kokedama_1_xkqscw.png" },
    { cat: "Green Walls", url: "https://res.cloudinary.com/dvtaslagk/image/upload/q_auto/f_auto/v1777018977/greenwall_ejwmmd.jpg" },
    { cat: "Balcony Gardens", url: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?auto=format&fit=crop&w=1200&q=80" },
    { cat: "Before / After", url: "https://res.cloudinary.com/dvtaslagk/image/upload/q_auto/f_auto/v1778769283/before_after_aaa8zg.jpg" },
    { cat: "Kokedama", url: "https://images.unsplash.com/photo-1760863264489-b051feacddaf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHw0fHxrb2tlZGFtYSUyMHBsYW50fGVufDB8fHx8MTc3Njc2NDQxNHww&ixlib=rb-4.1.0&q=85&w=1400" },
    { cat: "Indoor Setups", url: "https://images.pexels.com/photos/4505176/pexels-photo-4505176.jpeg?auto=compress&cs=tinysrgb&w=1200" },
];

export const TESTIMONIALS = [
    {
        name: "Priya Deshmukh",
        role: "Homeowner, Vashi",
        text:
            "Neha transformed our 6×4 balcony into a calm green corner. Plants are still thriving a year later — that says everything.",
    },
    {
        name: "Rohan Mehta",
        role: "Café owner, Navi Mumbai",
        text:
            "Our green wall was dying. Butterfly Lawn revived it in 3 weeks with a clear maintenance plan. Honest, expert, affordable.",
    },
    {
        name: "Anjali K.",
        role: "Gifting Client",
        text:
            "The Kokedama I ordered for my sister's wedding was gorgeous. Handmade and delivered on time. Will order again.",
    },
    {
        name: "Suresh Iyer",
        role: "Society Committee, Kopar",
        text:
            "Finally — a gardener who actually shows up and knows what they're doing. Our society garden has never looked better.",
    },
];

export const WHY_US = [
    { t: "Expert Knowledge", d: "BSc Agriculture background — science-backed care." },
    { t: "Personalized Advice", d: "Plants picked for your light, space and lifestyle." },
    { t: "Timely Service", d: "We show up when we say we will. Every time." },
    { t: "Budget Friendly", d: "Honest pricing. No upsell. No surprises." },
];

export const TRUST = [
    "BSc Agriculture Expert",
    "Reliable Service",
    "Affordable Pricing",
    "Healthy Plants Guarantee",
];

export const PRODUCTS = [
    {
        name: "Signature Kokedama",
        price: "From ₹299",
        tag: "Bestseller",
        image:
            "https://res.cloudinary.com/dvtaslagk/image/upload/q_auto/f_auto/v1777019709/kokedama_1_xkqscw.png",
    },
    {
        name: "Hanging Kokedama Set",
        price: "From ₹2,199",
        tag: "Gift Ready",
        image:
            "https://images.unsplash.com/photo-1760863264489-b051feacddaf?crop=entropy&cs=srgb&fm=jpg&w=1000&q=85",
    },

    {
        name: "Snake Plant",
        price: "From ₹349",
        image:
            "https://res.cloudinary.com/dvtaslagk/image/upload/q_auto/f_auto/v1778769013/snakeplant_xvdxsl.png",
    },

    {
        name: "Aglonema",
        price: "From ₹349",
        image:
            "https://res.cloudinary.com/dvtaslagk/image/upload/q_auto/f_auto/v1777020284/Aglonema_vroefi.png",
    },
    {
        name: "Cactus",
        price: "From ₹549",
        image:
            "https://res.cloudinary.com/dvtaslagk/image/upload/q_auto/f_auto/v1778769745/cactus_zmlmu9.jpg",
    },
    {
        name: "chamaedorea elegans(palm)",
        price: "From ₹199",
        image:
            "https://res.cloudinary.com/dvtaslagk/image/upload/q_auto/f_auto/v1777020433/chamaedorea_xaolbf.png",
    },
    {
        name: "Terracotta Pot Trio",
        price: "From ₹699",
        image:
            "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?auto=format&fit=crop&w=1000&q=80",
    },
];
